import React from 'react';
import styled from "styled-components";
import ProfileImage from "./ProfileImage";
import useZibi from "../zibi/UseZibi";
import Paper from "@mui/material/Paper";
import CommonProductInCart from "./cart/CommonProductInCart";
import Divider from "@mui/material/Divider";

const ContentStyled = styled.div`
  text-align: center;
  margin-bottom: 10px;
  display: block;
  padding: 10px;
`;

const WrapperStyled = styled.div`
  min-width: 64px;
  min-height: 120px;
  padding: 5px;
  color: var(--mui-palette-primary-main);
  margin: auto;

  &:hover {
    background-color: rgba(var(--mui-palette-primary-mainChannel) / var(--mui-palette-action-hoverOpacity));
  }

  &.active {
    color: var(--mui-palette-primary-contrastText);
    background-color: var(--mui-palette-primary-main);
  }

  .profile-image {
    display: grid;
    justify-content: center;
  }

  .shopper-name {
    margin-top: 8px;
    word-wrap: break-word;
  }
`;

const ProfileWrapperStyled = styled.div`
  grid-template-columns: auto 1fr;
  display: grid;
  text-align: left;
  grid-gap: 5px;
  padding: 2px 20px;
`;


const CartWrapperStyled = styled.div`
  overflow-y: auto;

`;

const ShopperProfileWithCart = ({shopper, cartData}) => {
    const [productsById] = useZibi('productsById');

    return (
        <ContentStyled>
            <Paper elevation={3}>
                <WrapperStyled>
                    <ProfileWrapperStyled data-shopper={shopper._id}>
                        <ProfileImage
                            imageUrl={shopper.imageUrl}
                            name={shopper.name}
                        />
                        <div className="shopper-name">
                            {shopper.name}
                        </div>
                    </ProfileWrapperStyled>
                    <Divider/>
                    <CartWrapperStyled>
                        {cartData && cartData.cart && (
                            <CommonProductInCart
                                isPlayMode={true}
                                productsCart={cartData.cart}
                                productsById={productsById}
                                showEmptyCartIcon={false}
                                showChangeViewIcon={false}
                            />
                        )}
                    </CartWrapperStyled>
                </WrapperStyled>
            </Paper>
        </ContentStyled>
    );
};

export default ShopperProfileWithCart;